import { SaveClientReportLinkForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveClientReportLinkModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveClientReportLinkModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save link'
      subTitle='Enter details in order to save it to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveClientReportLinkForm.FC
        id={props.id}
        clientReportId={params.clientReportId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
